import Component from '../colorz/Component';
import device   from '../colorz/utils/device';
import Flickity from 'flickity-imagesloaded';

/*
 * Slider Collections Enfant Direct
 * voir template strate-collections_slider.php
 */

module.exports = class CollectionsClassicSlider extends Component{
    onInit( el, args ) {
        this.onNext     = this.onNext.bind(this);
        this.onPrev     = this.onPrev.bind(this);
        this.onSelect   = this.onSelect.bind(this);
        this.el         = el;
        this.slides     = this.el.querySelectorAll('.js-slide');

        if (window.matchMedia("(min-width:1080px)").matches) {
            this.nextBtn    = this.el.querySelector('.next');
            this.prevBtn    = this.el.querySelector('.prev');
            this.tabsContainer = this.el.parentNode.querySelector('.js-slider-tabs');
            this.tabs = this.tabsContainer.querySelectorAll('.js-slider-tab');
        }
    }

    onReady() {

        // adds '.js-slide'
        this.addSlideClass();

        // init slider
        this.initSlider();

        if (window.matchMedia("(min-width:1080px)").matches) {
            // events on nav buttons
            this.nextBtn.addEventListener( device.pointerdown, this.onNext );
            this.prevBtn.addEventListener( device.pointerdown, this.onPrev );

            if (this.tabsContainer && this.tabs){
                for (let i = 0; i < this.tabs.length; i++){
                    this.tabs[i].addEventListener( device.pointerdown, this.onSelect );
                }
            }
        }

        // disable horizontal scroll
        document.body.classList.add('js-has-flickity');
    }

    onNext() {
        this.slider.next();
        this.switchActiveTab();
    }

    onPrev() {
        this.slider.previous();
        this.switchActiveTab();
    }

    onSelect(e){
        if ( !e.target.classList.contains('js-slider-tab') ){
            return;
        }

        let tabs = Array.prototype.slice.call(this.tabs);
        let index = tabs.indexOf( e.target );

        this.slider.select( index );
        this.switchActiveTab();
    }

    switchActiveTab(){
        for (let i = 0; i < this.tabs.length; i++){
            this.tabs[i].classList.remove('active');
        }

        for (let i = 0; i < this.tabs.length; i++){
            if (this.slider.selectedIndex == this.tabs[i].dataset.id) {
                this.tabs[i].classList.add('active');
            }
        }
    }

    addSlideClass(){
        for (var i = 0; i < this.slides.length; i++){
            this.slides[i].classList.add('slide');
        }
    }

    initSlider(){
        var options = {
            cellSelector: '.slide',
            pageDots: false,
            cellAlign : 'left',
            prevNextButtons: false,
            wrapAround: true,
            imagesLoaded: true
        };

        // console.log( this.el )

        if (window.matchMedia("(max-width:1080px)").matches) {
            options.draggable = true;
        } else {
            options.draggable = false;
        }

        // init slider
        this.slider = new Flickity(this.el, options);

    }

};
